export default {"src":"/_next/static/media/blog.19be0f4f.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};